import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../utils/styleUtils';

import {I18nMessage} from '../../contexts/I18n';
import {Icon, iconConstants} from '../Icon';

import styles from './InfoBox.scss';

function InfoBox({content, contentI18n}) {

    return (
        <div className={styleUtils.toClasses(styles.infoBox)}>

            <Icon icon={iconConstants.ICON_INFO_CIRCLE}/>

            <div className={styleUtils.toClasses(styles.infoContent)}>

                {content}

                {contentI18n && (
                    <p className={'info-text'}>
                        <I18nMessage id={contentI18n}/>
                    </p>
                )}

            </div>
        </div>
    );
}


InfoBox.propTypes = {
    content: PropTypes.any,
    contentI18n: PropTypes.string
};

InfoBox.defaultProps = {};


export default InfoBox;
